module.exports = __webpack_public_path__ + "img/LittleClouds.85e3cbad.png";